import React, { Component } from 'react';
import '../Styles/AboutStyle.css';
import Spin from '../Images/Bikes.jpg';

export class About extends Component {
    displayName = this.name

    render() {
        return (
            <div>
                <div className="container">
                    <div className="row" style={{ margin: "auto" }}>
                        <div className="col-md-6">
                            <h2 style={{ textAlign: "center" }}>Membership Prices</h2>
                            <table className="about-table">
                                <tbody>
                                    <tr className="about-tr">
                                        <th></th>
                                        <th>1 Year</th>
                                        <th>2 Year</th>
                                        <th>3 Year</th>
                                    </tr>
                                    <tr className="about-tr">
                                        <td>Single</td>
                                        <td>$57.50</td>
                                        <td>$52.05</td>
                                        <td>$46.60</td>
                                    </tr>
                                    <tr className="about-tr">
                                        <td>Couple</td>
                                        <td>$68.40</td>
                                        <td>$62.95</td>
                                        <td>$57.50</td>
                                    </tr>
                                    <tr className="about-tr">
                                        <td>Family</td>
                                        <td>$79.30</td>
                                        <td>$73.85</td>
                                        <td>$68.40</td>
                                    </tr>
                                    <tr className="blank_row">
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr className="about-tr">
                                        <td>Sign Up Fee</td>
                                        <td>$100</td>
                                        <td>$100</td>
                                        <td>$100</td>
                                    </tr>
                                </tbody>
                            </table>

                            
                        </div>
                        <div className="col-md-6">
                            <h2 style={{ textAlign: "center" }}>Paid In Full Memberships</h2>
                            <table className="about-table">
                                <tbody>
                                    <tr className="about-tr">
                                        <th></th>
                                        <th>Single</th>
                                        <th>Couple</th>
                                        <th>Family</th>
                                    </tr>
                                    <tr className="about-tr">
                                        <td>3 Month</td>
                                        <td>$325</td>
                                        <td>$375</td>
                                        <td>$425</td>
                                    </tr>
                                    <tr className="about-tr">
                                        <td>4 Month</td>
                                        <td>$350</td>
                                        <td>$400</td>
                                        <td>$450</td>
                                    </tr>
                                    <tr className="about-tr">
                                        <td>6 Month</td>
                                        <td>$425</td>
                                        <td>$475</td>
                                        <td>$525</td>
                                    </tr>
                                    <tr className="about-tr">
                                        <td>1 Year</td>
                                        <td>$640</td>
                                        <td>$780</td>
                                        <td>$900</td>
                                    </tr>
                                    <tr className="about-tr">
                                        <td>2 Year</td>
                                        <td>$1080</td>
                                        <td>$1320</td>
                                        <td>$1560</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="row" style={{ margin: "auto" }}> 
                        <div className="col-md-4" style={{textAlign:"center"}}>
                            <img src={Spin} Alt="Bikes" style={{maxWidth:"300px", width:"100%", padding:"10px"}} />
                        </div>
                        <div className="col-md-8">
                            <h2 style={{ textAlign: "center" }}>Guest Policy</h2>
                            <p>We have a guest fee of $15 per visit. Guest must be 18 or older or accompanied by a parent. Photo ID is required and guest must sign a release of liability upon each entry. Maximum of 3 guest vistis per year and staff reserves the right to limit or deny guest entry.</p>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/About.js